import type { ReactNode } from "react";
import "./RapportkatalogCardDescription.css";
import { Paragraph } from "@digdir/designsystemet-react";

type RapportkatalogCardDescriptionProps = {
    label?: string;
    text: ReactNode;
};

export function RapportkatalogCardDescription({
    label = "Kort om rapporten",
    text,
}: RapportkatalogCardDescriptionProps) {
    return (
        <div className="rapportkatalog-card-description">
            <Paragraph className="rapportkatalog-card-label">{label}</Paragraph>
            <Paragraph className="rapportkatalog-card-description-text">{text || "-"}</Paragraph>
        </div>
    );
}
